import React from "react";
import PointBase from './Base/PointBase';
import { QRCode } from '../qrcode';
import { pointOptions } from "./ultil";

export default class RendererRect extends PointBase {
	
	/**
	 *
	 * @param $options
	 * @param $qrcode
	 * @param $name
	 */
	constructor($options: any = {}, $qrcode: QRCode, $name?: string) {
		
		const pointRender = ($options: any) => {
			let $opts= pointOptions($options, ['transform', 'width', 'height'], [],
				function ($opts: any){
					let { x, y, scale } = $opts || {};
					let size = 100 * scale;
					return Object.assign($opts, { "transform": `translate(${x},${y})`, width: size, height: size });
				});

			return (<><rect {...$opts} /></>);
		}
		
		Object.assign($options, { pos: pointRender })
		
		super($options, $qrcode, $name || 'RendererRect');
	}
}